<div class="choices-form">
  <ul class="choices-form__options">
    @for (option of options().controls; track option) {
      <li>
        <input
          class="choices-form__options__input fs__md"
          #questionOptions
          type="text"
          placeholder="Type your answer {{ isRankSort() ? 'Rank' : 'Option' }} {{ $index + 1 }}"
          [formControl]="option | toFormControl"
          [readonly]="disabled()"
          (keyup.enter)="$last ? onAddOption() : onJumpOption($index)"
          (keydown.backspace)="onDeleteOption($index)"
          (keydown.arrowup)="onJumpOption($index - 2)"
          (keydown.arrowdown)="onJumpOption($index)"
          (paste)="onPaste($event, $index)"
        />
      </li>
    }
  </ul>
</div>
